




















import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component
export default class CookieCard extends Vue {
  @Emit("confirm")
  Confirm(a: boolean) {
    return a;
  }
}
